import {
    RefreshCw,
    Download,
    UserPlus,
} from "lucide-react";

function AdminUserHeader({
    reload,
    onAddAdmin,
}) {

    return (

        <div className="admin-users-header">

            <div>

                <h1>Admin Users</h1>

                <p>
                    Manage administrator accounts and assign roles.
                </p>

            </div>

            <div className="admin-users-actions">

                <button
                    className="refresh-btn"
                    onClick={reload}
                >

                    <RefreshCw size={18} />

                    Refresh

                </button>

                <button
                    className="export-btn"
                >

                    <Download size={18} />

                    Export

                </button>

                <button
                    className="add-btn"
                    onClick={onAddAdmin}
                >

                    <UserPlus size={18} />

                    Add Admin

                </button>

            </div>

        </div>

    );

}

export default AdminUserHeader;